import { Checklist } from '@/types/checklist.type';
import { create } from 'zustand';

interface ShareChecklistState {
    checklist: Checklist | undefined;
    hasChecklistUpdatePermission: boolean;
    initChecklist: (checklist: Checklist) => void;
    setHasChecklistUpdatePermission: (hasUpdateChecklistPermission: boolean) => void;
    setChecklist: (checklist: Checklist) => void;
    reset: () => void;
}

export const useShareChecklistStore = create<ShareChecklistState>((set, get) => ({
    checklist: undefined,
    hasChecklistUpdatePermission: false,
    initChecklist: (checklist: Checklist) => {
        set((state) => ({ checklist }))
    },
    setHasChecklistUpdatePermission: (hasChecklistUpdatePermission: boolean) => {
        set({ hasChecklistUpdatePermission })
    },
    setChecklist: (checklist: Checklist) => {
        set((state) => ({ checklist }))
    },
    reset: () => {
        set((state) => ({ checklist: undefined }))
    }
}));
